import { render } from "./DashboardProjectCard.vue?vue&type=template&id=4f91909e&scoped=true"
import script from "./DashboardProjectCard.vue?vue&type=script&lang=js"
export * from "./DashboardProjectCard.vue?vue&type=script&lang=js"

import "./DashboardProjectCard.vue?vue&type=style&index=0&id=4f91909e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f91909e"]])

export default __exports__